import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Radio,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import icon from "../../Utils/Thumbnail.png";
import ButtonComp from "../MUI/Button";
//  - variant: 'default' | 'grid' | 'radio' | 'list' | 'button' | `Subtable`

const CardTamplate = ({
  variant = "grid",
  title = "Title",
  items = [],
  onSelect,
}) => {
  const isRadio = variant === "radio";
  const isGrid = variant === "grid";

  const defaultItems = [
    { id: "i1", title: "Default Item 1", subtitle: "Default subtitle 1" },
    { id: "i2", title: "Default Item 2", subtitle: "Default subtitle 2" },
    { id: "i3", title: "Default Item 3", subtitle: "Default subtitle 3" },
  ];

  const data = items && items.length > 0 ? items : defaultItems;

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        padding: "0 16px 16px 16px",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRadius: 1, // 6px
        border: "1px solid #D6C1CB",
        backgroundColor: "#FFF",
        boxSizing: "border-box",
        boxShadow:
          "0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: 64,
          padding: "8px 0",
          justifyContent: "space-between",
          alignItems: "center",
          alignSelf: "stretch",
          width: "100%",
        }}
      >
        <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
        {(variant === "list" || variant === "subtable") &&
          variant !== "button" &&
          variant !== "radio" && (
            <IconButton>
              <AddOutlinedIcon sx={{ width: "24px", height: "24px" }} />
            </IconButton>
          )}
        {variant !== "list" &&
          variant !== "subtable" &&
          variant !== "button" &&
          variant !== "radio" && (
            <IconButton>
              <ModeEditOutlineOutlinedIcon
                sx={{ width: "24px", height: "24px" }}
              />
            </IconButton>
          )}
      </Box>

      {(variant === "grid" || variant === "list") && (
        <Divider sx={{ width: "100%", marginBottom: "16px" }} />
      )}
      {variant == "default" && (
        <Typography variant="body2" color="text.secondary">
          Default Text
        </Typography>
      )}
      {variant === "radio" && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, width: "100%" }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",

                cursor: "pointer",
              }}
            >
              <Radio />
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
              >
                Subtext
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      {variant === "list" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          {data.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                padding: "8px",
                cursor: "pointer",
              }}
              // onClick={() => onSelect && onSelect(item)}
            >
              <img
                style={{ width: "80px", height: "76px" }}
                src={icon}
                alt="icon"
              />
              <Box>
                <Typography sx={{ fontWeight: 500 }}>
                  {"[Degree Attained], [Field of Study]"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  [Institution]
                </Typography>

                <Typography variant="body2" color="text.secondary" mt="8px">
                  Graduation Year
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
      {variant === "grid" && (
        <Grid container spacing={0} sx={{ gap: "16px", width: "100%" }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Grid item key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 0,
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#21191E",

                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                  }}
                >
                  Field
                </Typography>

                <Typography
                  sx={{
                    color: "#21191E",
                    fontFamily: "Roboto",
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                  }}
                >
                  Default value
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
      {variant === "subtable" && (
        <TableContainer overFlow="auto">
          <Table>
            <TableHead>
              <TableRow>
                {Array.from({ length: 5 }).map((_, i) => (
                  <TableCell key={i} sx={{ fontWeight: 700, fontSize: 13 }}>
                    Header
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody
              sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
            >
              <TableRow>
                {Array.from({ length: 5 }).map((row, ri) => (
                  <TableCell key={ri} sx={{ py: 0.5 }}>
                    {" "}
                    Item {ri + 1}{" "}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {Array.from({ length: 5 }).map((row, ri) => (
                  <TableCell key={ri} sx={{ py: 0.5 }}>
                    {" "}
                    Item {ri + 1}{" "}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {Array.from({ length: 5 }).map((row, ri) => (
                  <TableCell key={ri} sx={{ py: 0.5 }}>
                    {" "}
                    Item {ri + 1}{" "}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {Array.from({ length: 5 }).map((row, ri) => (
                  <TableCell key={ri} sx={{ py: 0.5 }}>
                    {" "}
                    Item {ri + 1}{" "}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {variant === "button" && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Button Text
          </Typography>
          <ButtonComp style={{  gap: "8px",marginTop:"16px" }}>
            <LaunchOutlinedIcon sx={{ width: "18px", height: "18px" }} />
            <Typography>Button</Typography>
          </ButtonComp>
        </Box>
      )}
    </Box>
  );
};

export default CardTamplate;
